module.exports = __webpack_public_path__ + "img/vertical_7_6_6000.2973dc15.png";